import { render } from "./AdminVoiceGoals.vue?vue&type=template&id=620255cf&scoped=true"
import script from "./AdminVoiceGoals.vue?vue&type=script&lang=js"
export * from "./AdminVoiceGoals.vue?vue&type=script&lang=js"

import "./AdminVoiceGoals.vue?vue&type=style&index=0&id=620255cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620255cf"]])

export default __exports__